import { render, staticRenderFns } from "./SubdiviosionsGrid.vue?vue&type=template&id=1f8717a6"
import script from "./SubdiviosionsGrid.vue?vue&type=script&lang=js"
export * from "./SubdiviosionsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports